import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import Routes from "./routes/routes";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { validateEnvironment } from "./utils/envValidator";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import "./styles/common.css";
import * as serviceWorker from "./serviceWorker";

// Validate environment configuration before starting app
validateEnvironment();

// Font loading optimization
if ("fonts" in document) {
  // Preload only the most essential fonts first
  Promise.all([
    document.fonts.load("300 1em Celias"),
    document.fonts.load("normal 1em Celias"),
    document.fonts.load("bold 1em Celias")
  ]).then(() => {
    document.documentElement.classList.add("fonts-loaded");
  });
}

ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("root")
);

// Register instead of unregister to enable caching and offline capabilities
serviceWorker.register();
